/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import DataTable from 'react-data-table-component'
import {Link} from 'react-router-dom'
import axios from 'axios'
import Swal from 'sweetalert2'
import {TransferDeviceModal} from './TransferDeviceModal'
import {useUser} from '../../modules/newauth/UserContext'
import {stringFormatter} from '../../utils/stringFormatter'
import {handleRenameDevice} from './function/renameDevice'
import firebase from '../../firebase/FirebaseConfig'
import apiConnect from '../../api/apiConnect'
import {useThemeMode} from '../../../_metronic/partials'

import {Dropdown} from 'react-bootstrap' // หรือใช้ custom dropdown ก็ได้

const DashboardWrapper = () => {
  const [deviceData, setDeviceData] = useState([])
  const [trigger, setTrigger] = useState(true)
  const [transferDeviceModal, setTransferDeviceModal] = useState(false)
  const [selectedTransferDevice, setSelectedTransferDevice] = useState({})
  const [userList, setUserList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [modeUser, setModeUser] = useState(() => {
    return localStorage.getItem('device_dashboard_mode') || 'user'
  })
  const firestore = firebase.firestore()
  const [pinnedDevices, setPinnedDevices] = useState([])
  const {user} = useUser()
  const {mode} = useThemeMode()
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768)
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    async function fetchData() {
      if (modeUser === 'admin' && user?.role !== 'admin') {
        try {
          const response = await apiConnect.get(`/v1/devices/${user.userIdMalin1}`)
          setDeviceData(response.data)
        } catch (error) {
          console.error('Error fetching data:', error)
        }

        setModeUser('user')
        localStorage.setItem('device_dashboard_mode', 'user')
      } else if (modeUser === 'user') {
        setDeviceData([])

        try {
          const response = await apiConnect.get(`/v1/devices/${user.userIdMalin1}`)
          setDeviceData(response.data)
        } catch (error) {
          console.error('Error fetching data:', error)
        }
      } else if (modeUser === 'admin') {
        setDeviceData([])
        try {
          const response = await apiConnect.get('/v1/devices/all-device')
          setDeviceData(response.data)
        } catch (error) {
          console.error('Error fetching data:', error)
        }
      }
    }

    if (user) {
      fetchData()
    }
  }, [trigger, user, modeUser])

  useEffect(() => {
    const fetchPinnedDevices = async () => {
      firestore
        .collection('pinnedDevices')
        .where('userId', '==', user?.userId)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            setPinnedDevices(doc.data().deviceId || [])
          })
        })
        .catch((error) => {
          console.log('Error getting documents: ', error)
        })
    }

    if (user?.userId) {
      fetchPinnedDevices()
    }
  }, [user])

  const columns = isMobile
    ? [
        {
          name: 'Device',
          selector: (row) => row.name,
          cell: (row) => {
            return (
              <p
                style={{
                  minWidth: '250px',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  margin: 0,
                }}
              >
                {row.last_status == 'online' ? (
                  <>
                    <Link to={`/device/${row.device_id}`}>
                      <span className='badge badge-success badge-circle w-10px h-10px me-3'></span>
                      <span className='fs-6'> {row.name}</span>
                    </Link>
                    {pinnedDevices.includes(row.device_id) ? (
                      <i
                        title='Unpin'
                        onClick={() => handleTogglePin(row.device_id)}
                        className='fas fa-thumbtack ms-3 fs-5'
                        style={{color: '#ffc700', cursor: 'pointer'}}
                      ></i>
                    ) : (
                      <i
                        title='Pin to top'
                        onClick={() => handleTogglePin(row.device_id)}
                        className='fas fa-thumbtack ms-3'
                        style={{color: '#d8d8d9', cursor: 'pointer'}}
                      ></i>
                    )}
                  </>
                ) : (
                  <>
                    <Link to={`/device/${row.device_id}`}>
                      <span className='badge badge-dark badge-circle w-10px h-10px me-3'></span>
                      <span> {row.name}</span>
                    </Link>

                    {pinnedDevices.includes(row.device_id) ? (
                      <i
                        title='Unpin'
                        onClick={() => handleTogglePin(row.device_id)}
                        className='fas fa-thumbtack ms-3 fs-5'
                        style={{color: '#ffc700', cursor: 'pointer'}}
                      ></i>
                    ) : (
                      <i
                        title='Pin to top'
                        onClick={() => handleTogglePin(row.device_id)}
                        className='fas fa-thumbtack ms-3'
                        style={{color: '#d8d8d9', cursor: 'pointer'}}
                      ></i>
                    )}
                  </>
                )}
              </p>
            )
          },
        },
        {
          name: '',
          cell: (row) => (
            <Dropdown>
              <Dropdown.Toggle variant='light' size='sm'>
                Options
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => handleRenameDevice(row, trigger, setTrigger)}>
                  <i className='fas fa-pen-to-square me-3 ms-2'></i>
                  <span>Edit</span>
                </Dropdown.Item>

                {user?.role === 'admin' && (
                  <>
                    <Dropdown.Item onClick={() => handleTransferDevice(row)}>
                      <i className='fas fa-right-left me-2 ms-2'></i>
                      <span>Transfer</span>
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => handleRemoveDevice(row)}>
                      <i className='fas fa-trash-can me-2 ms-2'></i>
                      <span>Delete</span>
                    </Dropdown.Item>
                  </>
                )}
              </Dropdown.Menu>
            </Dropdown>
          ),
        },
      ]
    : [
        {
          name: 'Device Name',
          selector: (row) => row.name,
          sortable: true,
          width: '250px',
          cell: (row) => {
            return (
              <p
                style={{
                  maxWidth: '250px',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  margin: 0,
                }}
              >
                {row.last_status == 'online' ? (
                  <>
                    <Link to={`/device/${row.device_id}`}>
                      <span className='badge badge-success badge-circle w-10px h-10px me-3'></span>
                      <span className='fs-6'> {row.name}</span>
                    </Link>
                    {pinnedDevices.includes(row.device_id) ? (
                      <i
                        title='Unpin'
                        onClick={() => handleTogglePin(row.device_id)}
                        className='fas fa-thumbtack ms-3 fs-5'
                        style={{color: '#ffc700', cursor: 'pointer'}}
                      ></i>
                    ) : (
                      <i
                        title='Pin to top'
                        onClick={() => handleTogglePin(row.device_id)}
                        className='fas fa-thumbtack ms-3'
                        style={{color: '#d8d8d9', cursor: 'pointer'}}
                      ></i>
                    )}
                  </>
                ) : (
                  <>
                    <Link to={`/device/${row.device_id}`}>
                      <span className='badge badge-dark badge-circle w-10px h-10px me-3'></span>
                      <span> {row.name}</span>
                    </Link>

                    {pinnedDevices.includes(row.device_id) ? (
                      <i
                        title='Unpin'
                        onClick={() => handleTogglePin(row.device_id)}
                        className='fas fa-thumbtack ms-3 fs-5'
                        style={{color: '#ffc700', cursor: 'pointer'}}
                      ></i>
                    ) : (
                      <i
                        title='Pin to top'
                        onClick={() => handleTogglePin(row.device_id)}
                        className='fas fa-thumbtack ms-3'
                        style={{color: '#d8d8d9', cursor: 'pointer'}}
                      ></i>
                    )}
                  </>
                )}
              </p>
            )
          },
        },
        {
          name: 'Device ID',
          selector: (row) => row.device_id,
          sortable: true,
          cell: (row) => {
            return (
              <>
                <p className='fs-9'>{row.device_id}</p>
              </>
            )
          },
        },
        {
          name: 'Status',
          selector: (row) => (row?.linkWithClearBlade ? 'clearblade' : null),
          sortable: true,
          cell: (row) => {
            return (
              <>
                {row.premium ? (
                  <span className='badge badge-light-info'>Premium</span>
                ) : (
                  <span className='badge badge-light-dark'>STD</span>
                )}

                {row?.linkWithClearBlade ? (
                  <span className='badge badge-light-success ms-2'>ClearBlade</span>
                ) : (
                  ''
                )}
              </>
            )
          },
        },
        {
          id: 'lastUpdate',
          name: 'Last Update',
          selector: (row) => row.timestamp,
          sortable: true,
          cell: (row) => {
            return <p>{getTimeFormat(row.timestamp)}</p>
          },
        },
        {
          name: 'Type',
          selector: (row) => row.type,
          sortable: true,
          width: '100px',
          cell: (row) => {
            return <p>{stringFormatter(row.type)}</p>
          },
        },
        {
          name: ' ',
          cell: (row) => (
            <Dropdown>
              <Dropdown.Toggle variant='light' size='sm'>
                Options
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => handleRenameDevice(row, trigger, setTrigger)}>
                  <i className='fas fa-pen-to-square me-3 ms-2'></i>
                  <span>Edit</span>
                </Dropdown.Item>

                {user?.role === 'admin' && (
                  <>
                    <Dropdown.Item onClick={() => handleTransferDevice(row)}>
                      <i className='fas fa-right-left me-2 ms-2'></i>
                      <span>Transfer</span>
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => handleRemoveDevice(row)}>
                      <i className='fas fa-trash-can me-2 ms-2'></i>
                      <span>Delete</span>
                    </Dropdown.Item>
                  </>
                )}
              </Dropdown.Menu>
            </Dropdown>
          ),
        },
        ...(modeUser === 'admin'
          ? [
              {
                name: 'Owner',
                selector: (row) => row.ownerEmail,
                sortable: true,
                cell: (row) => {
                  return <p className='fs-7'>{row.ownerEmail}</p>
                },
              },
            ]
          : []), // ถ้า modeUser ไม่ใช่ admin จะไม่แสดง column นี้
        // {
        //   name: ' ',
        //   selector: (row) => row.type,
        //   sortable: true,
        //   width: '350px',
        //   cell: (row) => {
        //     return (
        //       <>
        //         <div className='d-flex'>
        //           <div
        //             className='btn btn-light-primary btn-sm d-inline-flex align-items-center'
        //             style={{minWidth: '80px', whiteSpace: 'nowrap'}}
        //             onClick={() => handleRenameDevice(row, trigger, setTrigger)}
        //           >
        //             <i className='fas fa-pen-to-square me-2'></i>
        //             <span>Edit</span>
        //           </div>

        //           {user?.role === 'admin' && (
        //             <>
        //               <div
        //                 className='btn btn-light-info btn-sm d-inline-flex align-items-center ms-2'
        //                 style={{minWidth: '80px', whiteSpace: 'nowrap'}}
        //                 onClick={() => handleTransferDevice(row)}
        //               >
        //                 <i className='fas fa-right-left me-2'></i>
        //                 <span>Transfer</span>
        //               </div>

        //               <div
        //                 className='btn btn-light-danger btn-sm d-inline-flex align-items-center ms-2'
        //                 style={{minWidth: '80px', whiteSpace: 'nowrap'}}
        //                 onClick={() => handleRemoveDevice(row)}
        //               >
        //                 <i className='fas fa-trash-can me-2'></i>
        //                 <span>Delete</span>
        //               </div>
        //             </>
        //           )}
        //         </div>
        //       </>
        //     )
        //   },
        // },
      ]

  const handleRemoveDevice = (row) => {
    const parameter = row.sensor
    const settingparameter = row.setting_parameter
    const statusParameter = row.status_parameter
    const digitalOutput = row.digital_output

    if (
      parameter.length > 0 ||
      settingparameter.length > 0 ||
      statusParameter.length > 0 ||
      digitalOutput.length > 0
    ) {
      Swal.fire({
        icon: 'error',
        title: 'This device is still in use and cannot be deleted.',
        text: 'Please remove all the parameter in the device before deleting it.',
      })
    } else {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this device!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const payload = {
            deviceId: row.device_id,
          }

          try {
            const response = await apiConnect.post('/v1/devices/remove-device', payload)
            Swal.fire({
              icon: 'success',
              title: 'Remove device successfully!',
            }).then(() => {
              setTrigger(!trigger)
            })
          } catch (error) {
            console.error('Error fetching data:', error)
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Something went wrong!',
            })
          }

          Swal.fire('Deleted!', 'Your device has been deleted.', 'success')
        }
      })
    }
  }

  const handleTransferDevice = async (row) => {
    if (row.premium) {
      Swal.fire({
        icon: 'error',
        title: 'This device is premium and cannot be transferred.',
        text: 'Please change the device to standard before transferring it in Malin1.com.',
      })
    } else {
      setSelectedTransferDevice(row)
      setTransferDeviceModal(true)

      try {
        const response = await apiConnect.get('/v1/users/all-user')

        setUserList(response.data)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
  }

  const handleCloseModal = () => {
    setTransferDeviceModal(false)
    setSelectedTransferDevice({})
  }

  // // เพิ่มการกรองข้อมูลบน DataTable ก่อนแสดงผล
  // const filteredData = deviceData?.filter(
  //   (device) =>
  //     device?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     device?.ownerEmail?.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     device?.device_id?.toLowerCase().includes(searchTerm.toLowerCase())
  // )

  const filteredData = Array.isArray(deviceData)
    ? deviceData
        .filter(
          (device) =>
            device?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            device?.ownerEmail?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            device?.device_id?.toLowerCase().includes(searchTerm.toLowerCase())
        )
        .sort((a, b) => {
          const aPinned = pinnedDevices.includes(a.device_id)
          const bPinned = pinnedDevices.includes(b.device_id)

          if (aPinned && !bPinned) return -1
          if (!aPinned && bPinned) return 1

          return b.timestamp > a.timestamp ? 1 : -1
        })
    : []

  const handleSwapMode = (newMode) => {
    setModeUser(newMode)
    localStorage.setItem('device_dashboard_mode', newMode)
  }

  const handleTogglePin = async (deviceId) => {
    const db = firebase.firestore()
    const pinnedRef = db.collection('pinnedDevices')
    let foundDocId = null
    let existingPinned = []

    try {
      const querySnapshot = await pinnedRef.where('userId', '==', user.userId).get()
      if (!querySnapshot.empty) {
        const doc = querySnapshot.docs[0]
        foundDocId = doc.id
        existingPinned = doc.data().deviceId || []
      }

      if (existingPinned.includes(deviceId)) {
        // 🔻 Unpin
        if (foundDocId) {
          await pinnedRef.doc(foundDocId).update({
            deviceId: firebase.firestore.FieldValue.arrayRemove(deviceId),
          })
        }
        setPinnedDevices(existingPinned.filter((id) => id !== deviceId))
      } else {
        // 📌 Pin
        if (foundDocId) {
          await pinnedRef.doc(foundDocId).update({
            deviceId: firebase.firestore.FieldValue.arrayUnion(deviceId),
          })
        } else {
          // ถ้าไม่มี doc เลย → สร้างใหม่
          await pinnedRef.add({
            userId: user.userId,
            deviceId: [deviceId],
          })
        }
        setPinnedDevices([...existingPinned, deviceId])
      }
    } catch (err) {
      console.error('Error pinning/unpinning device:', err)
    }
  }

  return (
    <>
      <div className='d-flex flex-wrap flex-stack mb-6'>
        <h3 className='fw-bolder my-2'>
          Dashboard
          {/* <span className='fs-6 text-gray-400 fw-bold ms-1'>(59)</span> */}
        </h3>

        <div className='d-flex my-2'>
          <ol className='breadcrumb text-muted fs-6 fw-bold'>
            <li className='breadcrumb-item pe-3'>
              <Link to={'/dashboard'} className='pe-3'>
                Home
              </Link>
            </li>
          </ol>
        </div>
      </div>

      <div
        className='card mb-5 mb-xl-10'
        style={
          modeUser === 'user'
            ? {
                // borderStyle: 'solid',
                // borderColor: '#3e97ff',
                // backgroundColor: '#eff6ff',
              }
            : {
                borderStyle: 'solid',
                borderColor: '#7239ea',
                backgroundColor: '#f0eafd',
              }
        }
      >
        <div className='card-header border-0 pt-2 d-flex justify-content-between align-items-center'>
          {/* Search Input & Button */}
          <div className='d-flex gap-2'>
            {/* Title */}

            {modeUser === 'user' && (
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bold fs-3 mb-1'>
                  My Devices ({filteredData?.length})
                </span>
              </h3>
            )}

            {modeUser === 'admin' && (
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bold fs-3 mb-1'>
                  All Devices ({filteredData?.length})
                </span>
              </h3>
            )}

            {user?.role === 'admin' && (
              <div className='form-check form-switch form-check-custom form-check-solid me-10'>
                <input
                  className='form-check-input h-30px w-50px'
                  type='checkbox'
                  id='flexSwitchModeToggle'
                  checked={modeUser === 'admin'}
                  onChange={(e) => handleSwapMode(e.target.checked ? 'admin' : 'user')}
                />
                <label className='form-check-label' htmlFor='flexSwitchModeToggle'>
                  {modeUser === 'admin' ? 'Admin Mode' : 'User Mode'}
                </label>
              </div>
            )}
          </div>

          {/* Search Input & Button */}
          {isMobile ? (
            <div className='d-flex flex-column flex-md-row gap-2 w-100'>
              <div className='input-group flex-grow-1  mt-3'>
                <span className='input-group-text'>
                  <i className='fas fa-search'></i>
                </span>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Search...'
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              {user?.role === 'admin' && (
                <Link to={`/create-new-device`}>
                  <div className='btn btn-primary w-100 w-md-auto mt-3'>Create new device</div>
                </Link>
              )}
            </div>
          ) : (
            <div className='d-flex gap-3 align-items-center'>
              <div className='input-group' style={{maxWidth: '250px'}}>
                <span className='input-group-text'>
                  <i className='fas fa-search'></i>
                </span>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Search...'
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              {user?.role === 'admin' && (
                <Link to={`/create-new-device`} className='my-2'>
                  <div className='btn btn-sm btn-primary'>Create new device</div>
                </Link>
              )}
            </div>
          )}
        </div>
        <div className='card-body border-top py-3'>
          <div className='table-responsive' style={{borderRadius: '10px'}}>
            <DataTable
              columns={columns}
              data={Array.isArray(filteredData) ? filteredData : []}
              pagination
              paginationPerPage={25}
              paginationRowsPerPageOptions={[25, 50, 100]}
              // defaultSortFieldId='lastUpdate'
              // defaultSortAsc={false}
              theme={mode === 'dark' ? 'dark' : 'light'}
            />
          </div>
        </div>
      </div>

      <TransferDeviceModal
        userList={userList}
        handleCloseModal={handleCloseModal}
        transferDeviceModal={transferDeviceModal}
        selectedTransferDevice={selectedTransferDevice}
        setSelectedTransferDevice={setSelectedTransferDevice}
        trigger={trigger}
        setTrigger={setTrigger}
      />
    </>
  )
}

export {DashboardWrapper}

function getTimeFormat(timestamp) {
  const createdAt = new Date(timestamp * 1000)
  const formattedDate = createdAt.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
  const formattedTime = createdAt.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
  const formattedDateTime = `${formattedDate} ${formattedTime}`
  return formattedDateTime
}
